module.exports = __webpack_public_path__ + "static/media/Diagramm.f529fa94.jpg";